export default function ChatgptSummarize() {
  return <h2>Chatgpt Summarize</h2>;
}
